import { render } from "./ResultType.vue?vue&type=template&id=1c0bda78&scoped=true"
import script from "./ResultType.vue?vue&type=script&lang=js"
export * from "./ResultType.vue?vue&type=script&lang=js"

import "./ResultType.vue?vue&type=style&index=0&id=1c0bda78&lang=scss&scoped=true"

import exportComponent from "/Users/konatsu/docker-static/speedo.devs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0bda78"]])

export default __exports__